import { create, Describe, string, type } from 'superstruct';

import { SapDownload } from '~extension/web2print/model/SapDownload';

export const SapDownloadValidator: Describe<SapDownload> = type({
  url: string(),
});

export function makeSapDownload(raw: unknown) {
  try {
    const sapDownload = create(raw, SapDownloadValidator);
    return sapDownload;
  } catch (err) {
    console.error(err);
  }
}
